import { EMAIL_REGEX, TEST_EMAIL_REGEX } from "@lib/constants";
import { z } from "zod";
const EmailSquema = z.string().refine(email => {
  const allowTestEmails = process.env.NEXT_PUBLIC_ALLOW_TEST_EMAILS === "true";
  if (allowTestEmails) {
    return TEST_EMAIL_REGEX.test(email);
  }
  return EMAIL_REGEX.test(email);
}, {
  message: "EMAIL_INVALID_MESSAGE"
});
export default EmailSquema;